export const THEME_CONSTANTS = {
  GLD: [
    { key: '--header-bg-color', value: '#fff' },
    { key: '--header-fg-color', value: '#080808' },
    { key: '--sub-header-bg-color', value: '#f2f1ef' },
    { key: '--sub-header-fg-color', value: '#5f5753' },
    { key: '--footer-heading-text-color', value: '#fff' },
    { key: '--footer-text-color', value: '#dfdbd7' },
    { key: '--footer-bg-color', value: '#330000' },
    { key: '--landing-footer-bg-color', value: '#351c15' },
    { key: '--landing-footer-text-color', value: '#bfb8af' },
    { key: '--primary-cta-bg', value: '#ffc400' },
    { key: '--primary-cta-fg', value: '#121212' },
    { key: '--primary-cta-hover-bg', value: '#ffd64c' },
    { key: '--primary-cta-disabled-bg', value: '#f2f1ef' },
    { key: '--primary-cta-disabled-fg', value: '#bfb8af' },
    { key: '--primary-cta-disabled-border-color', value: 'transparent' },
    { key: '--primary-cta-border-color', value: 'transparent' },
    { key: '--primary-cta-focus-border-color', value: '#5f5753' },
    { key: '--secondary-cta-bg', value: '#fff' },
    { key: '--secondary-cta-fg', value: '#0662bb' },
    { key: '--secondary-cta-hover-bg', value: '#e6eff8' },
    { key: '--secondary-cta-disabled-bg', value: '#fff' },
    { key: '--secondary-cta-disabled-fg', value: '#bfb8af' },
    { key: '--secondary-cta-disabled-border-color', value: '#bfb8af' },
    { key: '--secondary-cta-border-color', value: '#0662bb' },
    { key: '--secondary-cta-focus-border-color', value: '#5f5753' },
    { key: '--main-container-bg', value: '#f2f1ef' },
  ],
};
